<template>
  <el-form
    size="small"
    ref="editForm"
    label-position="top"
    :model="scale"
    :rules="rules"
  >

    <el-form-item label="Единица измерения" prop="unit">
      <el-input
        v-model="scale.unit"
      ></el-input>
    </el-form-item>
    <el-form-item label="Выше ожиданий" prop="expectation_above">
      <el-input
        v-model="scale.expectation_above"
        type="textarea"
      ></el-input>
    </el-form-item>
    <el-form-item label="Соответствует ожиданиям" prop="expectation_equal">
      <el-input
        v-model="scale.expectation_equal"
        type="textarea"
      ></el-input>
    </el-form-item>
    <el-form-item label="Частично соответствует ожиданиям" prop="expectation_partial">
      <el-input
        v-model="scale.expectation_partial"
        type="textarea"
      ></el-input>
    </el-form-item>


  </el-form>
</template>

<script>

import {dynamicScaleComponent} from "@/mixins/dynamicScaleComponent";
import requestSender from "@/api/base/requestSender";
import {variables} from "@/componentsCompany/smz/variables";
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "library-edit-form",
  mixins: [dynamicScaleComponent],
  components: {ClickToEdit},

  props: {},

  computed: {},

  watch: {},

  mounted() {
    this.$nextTick(function () {
      this.$refs.editForm.clearValidate();
    });
  },

  data() {
    return {
      scalesUnits: variables.scaleTypes,
      scaleTypes: variables.scaleTypes,
      elementCategories: variables.elementCategories,
      scaleTypesEnum: variables.scaleTypesEnum,

      scale:{
        unit: null,
        expectation_above: null,
        expectation_equal: null,
        expectation_partial: null,


      },

      rules: {}

    }
  },

  methods: {

  }
}
</script>

<style>

</style>